import styled from "styled-components";
import { ContentCard, PageContainer, PageHeader, PrimaryButton } from "../empresas/Empresas";

export default function Convenios() {
  return (
    <Container>
      <PageHeader>
        <div>
          <h1>Convênios</h1>
          <p>Cadastro e gerenciamento das convênios.</p>
        </div>

        <PrimaryButton type="button">
          Nova Clínica
        </PrimaryButton>
      </PageHeader>

      <ContentCard>
        <h2>Clínicas cadastradas</h2>
        <p>A listagem das clínicas será exibida aqui.</p>
      </ContentCard>
    </Container>
  );
}

const Container = styled.div`
  padding: 28px;
`;